var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71436 2C4.71436 0.89543 5.60979 0 6.71436 0H14.7144C15.8189 0 16.7144 0.895431 16.7144 2V10C16.7144 11.1046 15.8189 12 14.7144 12H6.71436C5.60979 12 4.71436 11.1046 4.71436 10V2ZM6.71436 1C6.16207 1 5.71436 1.44772 5.71436 2V10C5.71436 10.5523 6.16207 11 6.71436 11H14.7144C15.2666 11 15.7144 10.5523 15.7144 10V2C15.7144 1.44772 15.2666 1 14.7144 1H6.71436ZM2.71436 5C2.16207 5 1.71436 5.44772 1.71436 6V14C1.71436 14.5523 2.16207 15 2.71436 15H10.7144C11.2666 15 11.7144 14.5523 11.7144 14V13H12.7144V14C12.7144 15.1046 11.8189 16 10.7144 16H2.71436C1.60979 16 0.714355 15.1046 0.714355 14V6C0.714355 4.89543 1.60979 4 2.71436 4H3.71436V5H2.71436Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.ef8fd71a52cacfae9f4edb91dc2bc81d.svg";
export { ForwardRef as ReactComponent };